import MainStore from "../store/MainStore";

class UserPrefsService {

    getInitialesPrefs(){
        return   {
        "formulaire": {
            "header": {
                "value": true,
                    "type": "bool",
                    "label": "Mon entête sur les formulaires",
                    "disabled": false
            },
            "stamp": {
                "value": true,
                    "type": "bool",
                    "label": "Mon tampon sur les formulaires",
                    "disabled": false
            },
            "sign": {
                "value": true,
                    "type": "bool",
                    "label": "Mes références de signature",
                    "disabled": false
            },
            "date": {
                "value": true,
                    "type": "bool",
                    "label": "Date automatisée",
                    "disabled": false
            },
            "auto_code": {
                "value": true,
                    "type": "bool",
                    "label": "Génération du N° dossier",
                    "disabled": false
            },
            "prescription": {
                "value": false,
                    "type": "bool",
                    "label": "Description des prescriptions",
                    "disabled": false
            }
        },
        "notifications": {
            "command": {

                "value": true,
                    "type": "bool",
                    "label": "Confirmation de commande",
                    "disabled": false
            },
            "payement": {
                "value": true,
                    "type": "bool",
                    "label": "Confirmation de réglement (hors avoir)",
                    "disabled": false
            },
            "geo_update": {
                "value": true,
                    "type": "bool",
                    "label": "Mise à jour communale",
                    "disabled": false
            },
            "doc_update": {
                "value": true,
                    "type": "bool",
                    "label": "Mise à jour d’un document",
                    "disabled": false
            }
        },
        "interface": {
            "global_color": {
                "value": "dark",
                    "type": "text",
                    "label": "Style de l\'interface",
                    "disabled": false
            }
        },
        "map":{
            "center_lon": {
                "value": 8.802109,
                "type": "number",
                "label": "Centre - Longitude",
                "disabled": false
            },
            "center_lat": {
                "value": 41.946979,
                "type": "number",
                "label": "Centre - Latitude",
                "disabled": false
            },
            "zoom": {
                "value": 15,
                "type": "number",
                "label": "Zoom Initial",
                "disabled": false
            },
        },
        "layers": false ,
        "access":[
        {"id":0, "label": "Forfait", "title": "Information et relevé de propriété", "name":"relev_prop", "checked" : false},
        {"id":1, "label":"Forfait", "title": "Rensignement d’urbanisme", "name":"renseign_urba", "checked" : false},
        {"id":2, "label":"Forfait", "title": "Certificat d’urbanisme informatif", "name":"certif_urba", "checked" : false},
        {"id":3, "label":"Option", "title": "Baux agricoles", "name":"baux_aggri", "checked" : false},
        {"id":4, "label":"Option", "title": "Baux emphythéotiques", "name":"baux_emphy", "checked" : false},
        {"id":5, "label":"Option", "title": "Document d’urbanisme en cours d’élaboration", "name":"doc_elabor", "checked" : false},
        {"id":6, "label":"Shop", "title": "Consultation facture", "name":"shop_show_invoices", "checked" : false},
        ]
    }
    }




}

export default UserPrefsService
